<h3 mat-dialog-title>האם לצרף תמונה?</h3>
<div class="grid" style="place-items: center" mat-dialog-content>
	<app-mobility-image-container (imageFinishedUploading)="onNoClick()" [uploadImageToServerCallback]="uploadImageCallback" [maxImages]="1" [imagePrefix]="imagePrefix"></app-mobility-image-container>
</div>

<div mat-dialog-actions class="justify-center">
	<button mat-raised-button color="primary" mat-dialog-close>שליחה בלי תמונה</button>
</div>
